<template>
  <div class="client application-chat">
    <v-divider />
    <v-card-text style="height: 300px; overflow-y: scroll; overflow-x: hidden;" ref="messages-container">
      <div v-if="!messages[0] && !sending">
        <p>No messages yet.</p>
        <p class="grey--text">Send a message to start a conversation.</p>
        <p class="grey--text">Once messaged, a candidate can respond whenever they like.</p>
      </div>
      <Message
        v-for="chat in messages"
        :key="`chat-${chat.id}`"
        :chat="chat"
        flipped="Client"
      />
    </v-card-text>
    <v-divider />
    <v-card-actions v-if="applicationActive" class="px-0 py-0">
      <v-text-field box
        v-model="composing"
        :disabled="sending"
        placeholder="Type message to candidate and press enter"
        :append-icon="sending ? 'mdi-loading' : 'mdi-send'"
        @click:append="sendMessage"
        @keyup.enter.exact="sendMessage"
        color="primary"
      />
    </v-card-actions>
  </div>
</template>

<script>
// Components
import Message from '@/components/ChatMessage'

// Helpers
import _ from 'lodash'

export default {
  props: ['application', 'chats'],

  mounted() {
    this.scrollDown()
  },

  components: { Message },

  data() {
    return {
      composing: '',
      sending: false,
    }
  },

  computed: {
    messages() {
      var messages = this.chats
      return messages.sort(({ createdAt: a }, { createdAt: b }) => {
        if (new Date(a) > new Date(b)) return 1
        if (new Date(a) < new Date(b)) return -1
        return 0
      })
    },
    applicationActive() {
      return new Date(this.application.opportunity.commencesAt) > new Date()
    },
  },

  watch: {
    chats: {
      handler: function(value) {
        this.scrollDown()
      },
    },
  },

  methods: {
    sendMessage() {
      var chat = { content: this.composing }
      this.sending = true
      this.$http.post(`client/opportunities/${this.application.opportunity.id}/applications/${this.application.id}/chats`, chat).then(response => {
        this.composing = ''
      }).finally(() => {
        this.sending = false
        this.$store.dispatch('client/chats/fetchAll')
      })
    },

    scrollDown() {
      this.$nextTick(() => {
        const container = this.$refs['messages-container']
        if (container) container.scrollTop = container.scrollHeight
      })
    },

  },
}
</script>

<style>
.client.application-chat .v-input {
  font-size: 14px;
}
.client.application-chat .v-text-field .v-input__slot {
  margin-bottom: 0;
  border-radius: 0;
  min-height: 40px;
}
.client.application-chat .v-text-field .v-input__append-inner {
  margin-top: 8px;
}
.client.application-chat .v-text-field__details {
  display: none;
}
.client.application-chat .v-input input[type=text] {
  margin-top: 4px;
}

.client.application-chat i.mdi-loading {
  animation: rotation 2s infinite linear;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
</style>
